// extracted by mini-css-extract-plugin
export default {"footer":"ScoreCardFooter_footer__dtnHZ","footerIcon":"ScoreCardFooter_footerIcon__Y3ApB"};